import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/trim";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import { isEmpty } from "lodash";
export default function formatNicknames() {
  var _context;
  var nicknames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  if (isEmpty(nicknames)) {
    return [];
  }
  if (Array.isArray(nicknames) && !isEmpty(nicknames)) return nicknames;
  return _reduceInstanceProperty(_context = nicknames.split(',')).call(_context, function (acc, n) {
    var _context2;
    var trimmed = _trimInstanceProperty(n).call(n);
    return trimmed && trimmed.length > 0 ? _concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(acc), [trimmed]) : _toConsumableArray(acc);
  }, []);
}
//# sourceMappingURL=formatNicknames.js.map